import { isEmptyString } from '../../core/util/string';
import { getSearchDataFromQueryString } from '../../core/util/search';

export const getCobrandedSrpLocation = () =>
  (getSearchDataFromQueryString() as any).searchLocationPreferences?.cobrandedSrpLocation ?? null;

export const isCobrandedSrpLocation = () => !isEmptyString(getCobrandedSrpLocation());
